import { isWebView } from '../../utils/aem-utils';

export const webviewVideoPlayerModule = {
  name: 'Webview Video Player',
  shouldInit: () => isWebView(),
};
